
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.857 15.222C3.857 16.2 4.63 17 5.571 17h6.858c.942 0 1.714-.8 1.714-1.778V4.556H3.857v10.666zm1.714-8.889h6.858v8.89H5.57v-8.89zM12 1.89L11.143 1H6.857L6 1.889H3v1.778h12V1.889h-3z"}})])
          )
        }
      }
    